module.exports = __webpack_public_path__ + "img/38_28.869b2fe5.png";